export default "__VITE_PUBLIC_ASSET__dd66fbe2__"